@if (showFrom === "signUpPage") {
  <ng-template *ngTemplateOutlet="addIdentificationFormTemplate"></ng-template>
} @else {
  <div class="card dialog-box">
    <div class="card-header">
      <span class="float-end" (click)="closeDialogue(true)">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>

    <ng-container>
      <ng-template
        *ngTemplateOutlet="addIdentificationFormTemplate"
      ></ng-template>
      <!-- Action Buttons -->
      <div class="d-flex gap-1 pt-4">
        @if (selectedIdentification?.id) {
          <div class="col">
            <button
              type="button"
              class="btn btn-outline-danger w-100 btn-lg"
              (click)="deleteIdentification(selectedIdentification)"
            >
              Archive
            </button>
          </div>
        }
        <div class="col">
          <button
            type="button"
            class="btn btn-primary w-100 btn-lg"
            [disabled]="
              !identificationForm.valid ||
              (selectedIdentification?.id && !hasFormValuesChanged)
            "
            (click)="
              selectedIdentification?.id
                ? updateIdentification()
                : addIdentification()
            "
          >
            {{ selectedIdentification?.id ? "Update" : "Submit" }}
          </button>
        </div>
      </div>
    </ng-container>
  </div>
}
<ng-template #addIdentificationFormTemplate>
  <form [formGroup]="identificationForm">
    <div class="d-flex flex-wrap column-gap-3 row-gap-2 align-items-center">
      @if (
        showFrom === "manageIdentificationPage" && !selectedIdentification?.id
      ) {
        @if (
          focusedFieldDict?.assigneeField ||
          !identificationForm.value?.assignee_id
        ) {
          <ng-container>
            <gtapp-auto-complete
              [data]="assigneeList"
              placeHolder="Search User"
              searchKeyword="full_name"
              inputId="assigneeInputField"
              [itemTemplate]="assigneeTemplate"
              (inputChanged)="searchAssignee($event)"
              (selected)="
                selectDeselectSingleAssignee($event);
                focusedFieldDict.assigneeField = false;
                editField('id_type')
              "
              [enableCloseOption]="true"
              (fieldCleared)="editField('assignee_id')"
            >
            </gtapp-auto-complete>
            <ng-template #assigneeTemplate let-guard>
              <div>
                {{ guard?.full_name ? guard.full_name : guard.email }}
              </div>
            </ng-template>
          </ng-container>
        } @else {
          <ng-container>
            <dl class="p-2">
              <dt>User</dt>
              <dd
                class="link-edit"
                (click)="
                  focusedFieldDict.assigneeField = true;
                  editField('assignee_id')
                "
              >
                {{ selectedAssignee?.full_name }}
              </dd>
            </dl>
          </ng-container>
        }
      }

      <div>
        @if (focusedFieldDict?.credentialTypeFieldFocused) {
          <ng-container>
            <gtapp-auto-complete
              [data]="credentialTypeList"
              [maxLength]="256"
              placeHolder="Identification Type"
              searchKeyword="name"
              [initialValue]="identificationForm.value?.id_type"
              [itemTemplate]="credentialTypeTemplate"
              (inputChanged)="onSearchIdentificationType($event)"
              (selected)="
                onSelectIdentificationType($event);
                focusedFieldDict.credentialTypeFieldFocused = false;
                editField('issuer_state')
              "
              inputId="licTypeField"
              [enableCloseOption]="true"
              (fieldCleared)="editField('id_type')"
              (blurTriggered)="
                focusedFieldDict.credentialTypeFieldFocused =
                  !identificationForm.value?.id_type;
                filterLicenceClasses()
              "
            >
            </gtapp-auto-complete>

            <ng-template #credentialTypeTemplate let-item>
              <div>{{ item?.name_upper }}</div>
            </ng-template>
          </ng-container>
        } @else {
          <ng-container>
            <dl class="p-2">
              <dt>Identification Type</dt>
              <dd
                class="link-edit"
                (click)="focusedFieldDict.credentialTypeFieldFocused = true"
              >
                {{ identificationForm.value?.id_type }}
              </dd>
            </dl>
          </ng-container>
        }
      </div>
      <div>
        @if (
          focusedFieldDict?.stateFieldFocused ||
          !identificationForm.value?.issuer_state
        ) {
          <ng-container>
            <gtapp-auto-complete
              [data]="stateData"
              placeHolder="Issuing City/State (Optional)"
              searchKeyword="name"
              inputId="stateField"
              [initialValue]="issuerStateName"
              [itemTemplate]="stateTemplate"
              (inputChanged)="onStateSearch($event)"
              (selected)="
                onStateSelect($event);
                focusedFieldDict.stateFieldFocused = false
              "
              [enableCloseOption]="true"
              (fieldCleared)="editField('issuer_state')"
              (blurTriggered)="
                focusedFieldDict.stateFieldFocused =
                  !identificationForm.value?.issuer_state
              "
            >
            </gtapp-auto-complete>

            <ng-template #stateTemplate let-item>
              <div>{{ item?.name }}</div>
            </ng-template>
          </ng-container>
        } @else {
          <ng-container>
            <dl class="p-2">
              <dt>Issuer State (Optional)</dt>
              <dd
                class="link-edit"
                (click)="focusedFieldDict.stateFieldFocused = true"
              >
                {{ identificationForm.value?.issuer_state }}
              </dd>
            </dl>
          </ng-container>
        }
      </div>
      <div>
        @if (
          focusedFieldDict?.licClassField ||
          !identificationForm.value?.licence_class
        ) {
          <ng-container>
            <gtapp-auto-complete
              [data]="licenseClassData"
              placeHolder="Class / Category (Optional)"
              searchKeyword="name"
              inputId="licClassField"
              [initialValue]="licenseClassName"
              [itemTemplate]="identificationTemplate"
              (inputChanged)="onLicenceClassSearch($event)"
              (selected)="
                onlicenseSelect($event); focusedFieldDict.licClassField = false
              "
              [enableCloseOption]="true"
              (fieldCleared)="editField('licence_class')"
              (blurTriggered)="
                focusedFieldDict.licClassField =
                  !identificationForm.value?.licence_class
              "
            >
            </gtapp-auto-complete>

            <ng-template #identificationTemplate let-item>
              <div>{{ item?.name_upper }}</div>
            </ng-template>
          </ng-container>
        } @else {
          <ng-container>
            <dl class="p-2">
              <dt>Class</dt>
              <dd
                class="link-edit"
                (click)="focusedFieldDict.licClassField = true"
              >
                {{ identificationForm.value?.licence_class }}
              </dd>
            </dl>
          </ng-container>
        }
      </div>

      <!--  ID Number -->
      <gtapp-input-field
        dtValue="ID Number"
        inputId="id_number"
        [maxLength]="100"
        [inputStringValue]="identificationForm.value.id_number"
        (blurEmit)="identificationForm.controls['id_number'].setValue($event)"
      >
      </gtapp-input-field>

      <!--  Issue Date -->
      <div>
        <div class="d-flex align-items-center gap-2">
          @if (identificationForm.value?.issue_date) {
            <div class="form-floating">
              <input
                class="form-control"
                type="date"
                id="issue_date"
                formControlName="issue_date"
                placeholder="Date of Issue"
              />
              <label for="issue_date">Date of Issue</label>
            </div>
          }
          <div>
            <label for="issueDatePresentCheck">
              <input
                class="form-check-input"
                type="checkbox"
                id="issueDatePresentCheck"
                [checked]="identificationForm.value?.issue_date"
                (change)="dateFieldPresentCheck($event, 'issue_date')"
              />
              <span [class.fw-semibold]="identificationForm.value?.issue_date">
                Set Issue Date
              </span>
            </label>
          </div>
        </div>
      </div>
      <!--  Expiry Date -->
      <div>
        <div class="d-flex align-items-center gap-2">
          @if (identificationForm.value?.valid_till) {
            <div class="form-floating">
              <input
                class="form-control"
                type="date"
                id="valid_till"
                formControlName="valid_till"
                placeholder="Expiry"
                [min]="validDate"
              />
              <label for="valid_till">Expiry</label>
            </div>
          }
          <div>
            <label for="expiryCheck">
              <input
                class="form-check-input"
                type="checkbox"
                id="expiryCheck"
                [checked]="!identificationForm.value?.valid_till"
                (change)="dateFieldPresentCheck($event)"
              />
              <span [class.fw-semibold]="!identificationForm.value?.valid_till">
                No Expiry
              </span>
            </label>
          </div>
        </div>
      </div>
      <div class="mb-3">
        <dl>
          <dt class="mb-2">Photos of ID</dt>
          <dd class="d-flex gap-2 flex-wrap">
            @if (imageContainerCheck[1]?.file_url) {
              <div class="id-image-container">
                <div class="mb-2">
                  <img
                    (click)="onOpenFile(imageContainerCheck[1])"
                    src="{{ imageContainerCheck[1]?.file_url }}"
                    class="id-image"
                  />
                </div>
                <div class="text-center">
                  <button
                    class="btn btn-outline-danger btn-sm"
                    (click)="deletePhoto(imageContainerCheck[1], 1)"
                  >
                    <i class="fa-solid fa-circle-minus"></i>
                  </button>
                </div>
              </div>
            } @else {
              @if (totalFileSize < 8) {
                <div class="id-image-container">
                  <button
                    class="btn btn-outline-primary btn-sm id-image-placeholder"
                    (click)="uploadIdentificationFile(1)"
                  >
                    Front
                  </button>
                </div>
              }
            }
            @if (imageContainerCheck[2]?.file_url) {
              <div class="id-image-container">
                <div class="mb-2">
                  <img
                    (click)="onOpenFile(imageContainerCheck[2])"
                    src="{{ imageContainerCheck[2]?.file_url }}"
                    class="id-image"
                  />
                </div>
                <div class="text-center">
                  <button
                    class="btn btn-outline-danger btn-sm"
                    (click)="deletePhoto(imageContainerCheck[2], 2)"
                  >
                    <i class="fa-solid fa-circle-minus"></i>
                  </button>
                </div>
              </div>
            } @else {
              @if (totalFileSize < 8) {
                <div class="id-image-container">
                  <button
                    class="btn btn-outline-primary btn-sm id-image-placeholder"
                    (click)="uploadIdentificationFile(2)"
                  >
                    Back
                  </button>
                </div>
              }
            }
          </dd>
        </dl>
      </div>
    </div>
  </form>
</ng-template>
